import React, { useEffect, useState } from 'react'
import ButtonLink from '../../../../component/buttton/ButtonLink.component';
import { BiChevronRight, BiCog, BiChart, BiCalendarStar } from 'react-icons/bi';
import GridComponent from '../../../../component/grid/GridComponent.component';
import Grid from '@material-ui/core/Grid';
import Router from '../Details.container';
import { useParams } from "react-router";
import ParamTypes from '../../../../core/interfaces/ParamTypes';
import {AuthorizationOption} from '../../../../authorization/Authorization';
import {AUTORIZATION} from '../../../../enum/authorization/Authorization';

export default function Assessment() {

  let { id } = useParams<ParamTypes>();
  const [userPermission, setUserPermission] = useState(false);

  useEffect(() => {

    const permission = AuthorizationOption(AUTORIZATION.AVALIACAO_LOJA_GESTOR);

    setUserPermission(permission);

  },[])

  return (
    <>
      <GridComponent spacing={2}>
        <Grid item>
          <ButtonLink title='Informações Loja' link={`/loja/${id}/`} icon={<BiChevronRight color='#FFF' size={25} />} />
        </Grid>
        {
          userPermission === true ? (
            <>
              {/* <Grid item>
                <ButtonLink title='Indicadores Operacionais' link={`/loja/${id}/indicadores-operacionais`} icon={<BiCog color='#FFF' size={25} />} />
              </Grid> */}
              <Grid item>
                <ButtonLink title='Dashboard Avaliações' link={`/loja/${id}/dashboard`} icon={<BiChart color='#FFF' size={25} />} />
              </Grid>
              <Grid item>
                <ButtonLink title='Avaliações Funcionários' link={`/loja/${id}/avaliacao`} icon={<BiCalendarStar color='#FFF' size={25} />} />
              </Grid>
            </>
          ) : null
        }

        {/*<Grid item>
          <ButtonLink title='Cadastrar Avaliação' link={`/loja/:id/cadastrar-avaliacao`} icon={<FiPlusSquare color='#FFF' size={25} />} />
        </Grid>*/}
        {/* <Grid item>
          <ButtonLink title='Indicadores Operacionais' link={`/loja/${id}/indicadores`} icon={<BiCog color='#FFF' size={25} />} />
        </Grid> */}
      </GridComponent>
      <Router />
    </>
  )
}
